// @ts-strict-ignore
import {booleanAttribute, Component, Input} from "@angular/core";
import {AssessablePanelMode} from "@common/components/assessment/utils";
import {Translations} from "@translations";

@Component({
	selector: "sim-item-score",
	template: `
		<div
			class="scoreBadge"
			[ngClass]="{
				dimmed: dimmed,
				isKnockoutQuestion: isKnockout,
				small: small,
			}"
		>
			{{ score }}
		</div>
	`,
	styleUrl: "./item-score.component.scss",
	standalone: false,
})
export class ItemScoreComponent {
	protected readonly T = Translations;
	protected readonly AssessablePanelMode = AssessablePanelMode;
	@Input({required: true}) isKnockout: boolean;
	@Input({required: true}) dimmed: boolean;
	@Input({required: true}) score: number | "-";
	@Input({transform: booleanAttribute}) small = false;
}
